
import { DependencyLifeTime, Injectable } from "@miracledevs/paradigm-web-di";
import { ContextCollection } from "../../../contexts/DependencyContext";
import { ClientproxyApiClient } from "../clients/ClientproxyApiClient";
import { IIndicatorResult } from "./models/IIndicatorResult";
import { IGetIndicatorsParameters } from "./models/IGetIndicatorsParameters";
import { IIndicatorGroupResult } from "./models/IIndicatorGroupResult";

@Injectable({ collection: ContextCollection, lifeTime: DependencyLifeTime.Singleton })
export class IndicatorListService
{
	private readonly url: string;

	constructor(private readonly apiClient: ClientproxyApiClient)
    {
        this.url = "indicatorlist";
    }

    async getFailingIndicators(parameters: IGetIndicatorsParameters): Promise<IIndicatorResult[]>
    {
        return await this.apiClient.post<IIndicatorResult[]>(`${this.url}/failing`,{},JSON.stringify(parameters));
    }

    async getGroupedIndicators(parameters: IGetIndicatorsParameters): Promise<IIndicatorGroupResult[]>
    {
        return await this.apiClient.post<IIndicatorGroupResult[]>(`${this.url}/grouped`,{},JSON.stringify(parameters));
    }
}
